// Web mirror of the mobile MessageSeenStore: a local, per-conversation read
// pointer (convKey -> last-seen time in ms). Unread state is derived from this,
// NOT from server message status — same model as the app, just per browser.

const KEY = 'webSeen';

function readAll() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '{}');
  } catch {
    return {};
  }
}

function writeAll(map) {
  localStorage.setItem(KEY, JSON.stringify(map));
}

export function dmKey(otherUserId) {
  return `dm_${otherUserId}`;
}

export function groupKey(groupId) {
  return `group_${groupId}`;
}

export function getSeen(convKey) {
  return readAll()[convKey] || 0;
}

// Monotonic: only ever advances the pointer forward.
export function markSeen(convKey, timeMs = Date.now()) {
  const map = readAll();
  if (!map[convKey] || timeMs > map[convKey]) {
    map[convKey] = timeMs;
    writeAll(map);
  }
}
